import React from "react";
import "../OrderComponents/OrderTabs.css";
import { useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import api from "../../seller-apis/api";
import { displayRazorpay } from "../../utilities/razorPay";
import { useAlert } from "react-alert";
import { Actions } from "../../Actions/Actions";

// Global flag to track if wallet plans API has been called in this session
var walletPlansApiCalled = false;

const WalletPopup = ({ show, handleClose }) => {
  const walletAmt = useSelector(state => state.ActionReducer.WalletAmount);
  const [ballence, setBallance] = useState(6000);
  const [currWalletBal, setCurrWalletBal] = useState(6000);
  const [proceed, setProceed] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const dispatch = useDispatch();
  const Alert = useAlert();
  const containerStyle = {
    backgroundSize: "21%",
  };
  const badgeAmt = [500, 1000, 2000];
  // const changeBallence = (amt) => {
  //   setBallance(amt);
  // };

  useEffect(() => {
    if (walletPlansApiCalled) {
      return;
    }
    
    walletPlansApiCalled = true;
    
    api.customerLeads.getWalletPlans().then((data) => {
      console.log("Plans", data);
      setPlans(data?.data?.records || []);
      const res = data?.data?.records?.filter((item) => item?.best === true);
      setSelectedPlan(res[0]);
    }
    );
  }, [])
  useEffect(() => {
    setShowSuccess(false);
  }, [show])


  const addWalletAmt = (amt) => {
    let totalAmt = parseInt(amt) + ((parseInt(amt) * 18) / 100);
    const txType = "lead-unlock";

    displayRazorpay(totalAmt, amt, txType).then((data) => {
      if (data == "Amount exceeds maximum amount allowed.") {
        Alert.error(data);
      }
      else {
        setShowSuccess(true);
        Alert.success("Subscription activated successfully")
        getAmount();
        setTimeout(() => {
          handleClose();
        }, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  const getAmount = () => {
    api.customerLeads.getWalletBallence().then((data) => {
      setCurrWalletBal(data?.data?.record?.wallet?.currentBal);
      Actions.upadteWalletAmount(dispatch, data?.data?.record?.wallet || []);
    });
    //SL-710
    window.location.reload();
  }
  const handleInputChange = (e) => {
    // Allow only numbers (0-9) in the input
    const value = e.target.value.replace(/[^0-9]/g, '');
    setBallance(value);
  };

  const handlePlanClick = (item) => {
    console.log("item", item);
    setSelectedPlan(item)
  }

  const iconsForPlans = {
    "50000": <i className="bi bi-calendar4"></i>,
    "30000": <i className="bi bi-clock"></i>,
    "18000": <i className="bi bi-patch-check"></i>
  }
  return (
    <Modal className="wallet-modal" centered show={show} onHide={handleClose}>
      <Modal.Body>
        <div className="white-bg wallet-main">
          <div className="wallet-container" style={containerStyle}>
            <div className="close-button-wallet" onClick={() => handleClose()}>&times;</div>
            {!showSuccess ?
              <div className="lead-subscription-popup">
                <div className="title">Subscribe for Leads</div>
                <div className="sp-plans-cntn">
                  {
                    plans.map((item, index) => {
                      return (
                        <div className={`sp-plans ${selectedPlan?.price === item?.price ? 'sp-plan-active' : ""}`} key={index} onClick={() => { handlePlanClick(item) }}>
                          {item?.best ? <div className="sp-plan-best">Best Value</div> : <div className="sp-plan-best" style={{ background: "none" }}>{"\u00A0"}</div>}
                          <div className="sp-plan-icon">{iconsForPlans[item?.price]}</div>
                          <div className="sp-plan-duration">{item?.name}</div>
                          {item?.saveMsg ? <div className="sp-plan-discount">{item?.saveMsg}</div> : <div className="sp-plan-discount" style={{ background: "none" }}>{"\u00A0"}</div>}
                          <div className="sp-plan-amt"><i className="bi bi-currency-rupee"></i>
                            {new Intl.NumberFormat('en-IN').format(item?.price)}
                          </div>
                          <div className="sp-plan-per-month"><i className="bi bi-currency-rupee"></i>{item?.monthly}</div>
                        </div>
                      )
                    })
                  }
                  </div>
                  <div className="sp-plans-features-cntn">
                    <div className="row">
                      <div className="col-6">
                        <div className="sp-plan-feature"><i className="bi bi-rocket-takeoff"></i> Unlock Qualified Leads</div>
                      </div>
                      <div className="col-6" style={{textAlign: "left"}}>
                        <div className="sp-plan-features"><i className="bi bi-file-text"></i> Intelligent leads management system</div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <div className="sp-plan-features"><i className="bi bi-headset"></i> Priority Seller Support</div>
                      </div>
                      <div className="col-6" style={{textAlign: "left"}}>
                        <div className="sp-plan-features"><i className="bi bi-whatsapp"></i> Click to Whatsapp feature</div>
                      </div>
                    </div>
                  </div>
                <div className="wallet-button" onClick={()=>{addWalletAmt(selectedPlan?.price)}}>
                  <i className="bi bi-check-circle-fill"></i> Subscribe now for &#8377; {Math.round(parseInt(selectedPlan?.price)+((parseInt(selectedPlan?.price)*18)/100))}
                      <OverlayTrigger
                                                key="lead_subs"
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-lead_subs`} className="fs-14 order_page_tooltip">
                                                        <p className='fs-12 f-500 order_page_tooltip_1'> Including 18% GST</p>
                                                    </Tooltip>
                                                }
                                                >
                                                <i class="fa fa-info-circle" aria-hidden="true" style={{marginLeft:"5px"}}></i>
                      </OverlayTrigger>
                 </div>
              </div>
              :
              <div className="inner-data d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                <div className="text-center">
                  Subscription activated successfully
                </div>
              </div>
            }
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WalletPopup;
